import { useState, useEffect } from "react";
import axios from "axios";
import { ClipboardList, CheckCircle } from "lucide-react";

import { BACKEND_URL } from "../../apiConfig";

export default function TodoWidget() {
  const [todoData, setTodoData] = useState({ day: "", items: [] });
  const [checked, setChecked] = useState({});

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios.get(`${BACKEND_URL}/api/todo-list/today`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setTodoData(res.data))
      .catch(() => {});
  }, []);

  const toggle = (id) => setChecked(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <div className="flex flex-col h-full bg-white rounded-lg border border-zinc-200 overflow-hidden">
      <div className="bg-rose-600 text-white text-[11px] font-bold px-2 py-1 text-center flex items-center justify-center gap-1">
        <ClipboardList className="w-3 h-3" /> To-Do - {todoData.day}
      </div>
      <div className="flex-1 overflow-auto px-1.5 py-0.5">
        {todoData.items.length === 0 ? (
          <div className="text-[10px] text-zinc-400 text-center py-2">No tasks for today</div>
        ) : (
          todoData.items.map((item) => (
            <div
              key={item.id}
              className="flex items-start gap-1 py-0.5 border-b border-zinc-50 last:border-0 cursor-pointer"
              onClick={() => toggle(item.id)}
            >
              <CheckCircle className={`w-3 h-3 mt-0.5 flex-shrink-0 ${checked[item.id] ? "text-green-500" : "text-zinc-300"}`} />
              <span className={`text-[10px] leading-tight ${checked[item.id] ? "line-through text-zinc-400" : "text-zinc-700"}`}>
                {item.text}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
